<template>
  <div id="mainRewardsRef">
    <div class="top_line">
        <span class="mainName">{{dataObj.chapter1?dataObj.chapter1.baseInfo.mainName:'--'}}</span>
      </div>
    <el-card class="box-card reward">
    <div slot="header" class="clearfix">
      <span>交易主体奖惩信息</span>
    </div>
    <div class="card-item">
      <!-- <div class="card-title">
        <p
          v-for="(item,index) in tabList"
          :key="index"
          @click="tabToggle(index)"
          :class="{active:index === tabListIndex}"
        >{{item}}</p>
      </div> -->
      <div class="card-content">
        <!--  v-if="tabListIndex == 0" -->
        <div>奖励信息：</div>
        <rewardsList
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
          :dataSource="allDataListObj.prizeList"
        />
        <!-- v-if="tabListIndex == 1" -->
        <div>违法违规信息：</div>
        <illlegalList
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
          :dataSource="allDataListObj.punishList1"
        />
        <!--v-if="tabListIndex == 2"  -->
        <div>行政处罚信息：</div>
        <penaltyList
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
        />
        <!-- v-if="tabListIndex == 3" -->
        <div>不良行为：</div>
        <badBehaviorInformation
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
        />
        <!--  v-if="tabListIndex == 4" -->
        <div> 黑名单记录：</div>
        <blackListRecord
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
        />
        <!-- v-if="tabListIndex == 5" -->
        <div>失信联合惩戒：</div>
        <breakPromise
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
        />
        <!--  v-if="tabListIndex == 6" -->
        <div>信用河南公示信息：</div>
        <creditHenan
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
          :dataSource="allDataListObj.creditHnList"
        />
      </div>
      <div
        v-if="tabListIndex != 0 && tabListIndex != 6"
        class="remarks"
        style="margin-left: 24px;padding-bottom: 12px"
      >备注：系统自动归集信息来自国家信用信息公示平台及相关行业主管部门汇集数据库，自动归集信息只可查看，不可编辑！</div>
      <div
        v-if="tabListIndex != 0 && tabListIndex == 6"
        class="remarks"
        style="margin-left: 24px;padding-bottom: 12px"
      >备注：系统自动归集信息来自信用河南，自动归集信息只可查看，不可编辑！</div>
    </div>
  </el-card>
  </div>
 
</template>

<script>
import rewardsList from "./rewardsList";// 奖励信息
import illlegalList from "./illlegalList";//违法违规
import penaltyList from "./penaltyList";//行政处罚
import badBehaviorInformation from "./badbehaviorList";//不良行为
import blackListRecord from "./blackList";//黑名单
import breakPromise from "./breakPromiseList";//失信用联合惩戒
import creditHenan from "./creditHenanList";//信用河南公示信息
export default {
  name: "main-rewards-form",
  components: {
    rewardsList,
    illlegalList,
    penaltyList,
    badBehaviorInformation,
    blackListRecord,
    breakPromise,
    creditHenan,
    allDataListObj:{}
  },
  props: {
    entStatus: {
      type: Number,
      default: 99
    },
    pageStatus: {
      type: String,
      default: ""
    },
    dataObj: {
        type: Object,
        default: () => {}
      }
  },
  watch: {
    entStatus: {
      immediate: true,
      handler(val) {
        this.entStatusCopy = val;
      },
      deep: true
    },
    pageStatus: {
      immediate: true,
      handler(val) {
        this.pageStatusCopy = val;
      },
      deep: true
    },
    dataObj: {
      deep: true,
      immediate: true,
      handler(val) {
        this.allDataListObj =val.chapter7 ? val.chapter7: {};
      }
    }
  },
  data() {
    return {
      tabList: [
        "奖励信息",
        "违法违规信息",
        "行政处罚信息",
        "不良行为",
        "黑名单记录",
        "失信联合惩戒记录",
        "信用河南公示信息"
      ],
      tabListIndex: 0,
      entStatusCopy: "",
      pageStatusCopy: ""
    };
  },

  methods: {
    tabToggle(index) {
      this.tabListIndex = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.reward {
  .card-item {
    .card-title {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 100%;
      height: 55px;
      border-bottom: 1px solid #ccc;
      line-height: 55px;
      p {
        font-size: 16px;
        margin: 0 32px;
      }
      .active {
        color: #1890ff;
        border-bottom: 2px solid #1890ff;
        margin-bottom: 2px;
      }
    }

    .card-content {
      padding: 10px 0px;
    }
  }
}
#mainRewardsRef{
  border: 1px solid #d8d8d8;
  .top_line {
      width: 80%;
      height: 50px;
      color: #8a8a8a;
      margin: 0 auto;
      border-bottom: 1px solid #d8d8d8;
      position: relative;
      .mainName {
        position: absolute;
        bottom: 10px;
        right: 0;
      }
    }
}
</style>